/**
 * Escape a string for safe interpolation into innerHTML — covering BOTH
 * text content and quoted attribute values.
 *
 * The browser's textContent → innerHTML round-trip only escapes `&<>` because
 * those are the only entities text nodes need. Attribute values additionally
 * need `"` (and `'` for single-quoted attributes) to prevent breakout like
 * `src="${attackerUrl}"` with `attackerUrl = 'x" onerror="alert(1)`. We add
 * the quote escapes so one helper is safe in every context a template
 * literal produces.
 *
 * Use this helper whenever you're building HTML via template literals with
 * user- or organizer-controlled strings (team names, game titles, nicknames,
 * chat messages, media URLs). Forgetting to escape perpetuates stored XSS —
 * see the Session 30 join-view incident and the Session 47e media-URL
 * incident for cautionary tales.
 */
export function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
